import { axiosInstance } from "../../utility/apiInstance";
import { StatusFilter, TemplatePayload } from "./subscriptionTemplate.types";

const AIRBASE = "/api/v1/subscription-template";
const OCEANBASE = "/api/v1/ocean/template";

const baseFor = (mode: string) => (mode === "air" ? AIRBASE : OCEANBASE);

export const fetchTemplates = async (search = "", status: StatusFilter = "all", mode: string) => {
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status && status !== "all") params.set("status", status);
    const res = await axiosInstance.get(`${baseFor(mode)}?${params.toString()}`);
    return res.data?.data || [];
};

export const fetchMilestones = async (mode: string) => {
    const path = mode === "air" ? "/api/v1/mileStone" : "/api/v1/ocean/ocean-milestone";
    const res = await axiosInstance.get(path);
    const data = mode === "air" ? res?.data || [] : res?.data?.data || [];
    return data;
};

// Contacts (shared)
export const fetchContacts = async () => {
    const [emailResp, whatsappResp] = await Promise.all([
        axiosInstance.get("/api/v1/contact?channel=email"),
        axiosInstance.get("/api/v1/contact?channel=whatsapp"),
    ]);
    return {
        email: emailResp?.data?.data || [],
        whatsApp: whatsappResp?.data?.data || [],
    };
};

export const fetchWhatsappGroups = async () => {
    const res = await axiosInstance.get("/api/v1/whatsapp-group");
    return res.data?.data || [];
};

export const createTemplate = (payload: TemplatePayload, mode: string) =>
    axiosInstance.post(baseFor(mode), payload);

export const updateTemplate = (id: string | number, payload: TemplatePayload, mode: string) =>
    axiosInstance.patch(`${baseFor(mode)}/${id}`, payload);

export const deleteTemplate = (id: string | number, mode: string) =>
    axiosInstance.delete(`${baseFor(mode)}/${id}`);